<app-course-header></app-course-header>

<div class="UNFAPP-signlog-full-area">
    <div class="UNFAPP-signlog-frm-wrpbx">
        <div class="UNFAPP-signlog-frmbx">
            <div class="UNFAPP-signlog-hdng-wrap">
                <h2 class="UNFAPP-signlog-hdng">Welcome to Infinity Learn</h2>
                <h3 class="UNFAPP-signlog-stphdng _darkbold">You are 1 step away from starting your learning journey</h3>
            </div>
            <!-- <div class="UNFAPP-signlog-grdarea">
                <h3 class="UNFAPP-signlog-hdng lightbold sm-hdng">What grade are you in?</h3>
                <ul class="UNFAPP-grdlist-area">
                    <li *ngFor="let grade of grades" (click)="selectedGrade(grade)">
                        <label class="UNFAPP-grd-radio">
                            <input type="radio" name="grade">
                            <div class="UNFAPP-grd-radiobx">{{grade.name}}</div>
                        </label>
                    </li> -->
                    <!-- <li>
                        <label class="UNFAPP-grd-radio">
                            <input type="radio" name="grade" formControlName='grade' value='10th'>
                            <div class="UNFAPP-grd-radiobx">10th</div>
                        </label>
                    </li>
                    <li>
                        <label class="UNFAPP-grd-radio">
                            <input type="radio" name="grade" formControlName='grade' value='11th'>
                            <div class="UNFAPP-grd-radiobx">11th</div>
                        </label>
                    </li>
                    <li>
                        <label class="UNFAPP-grd-radio">
                            <input type="radio" name="grade" formControlName='grade' value='12th'>
                            <div class="UNFAPP-grd-radiobx">12th</div>
                        </label>
                    </li>
                    <li>
                        <label class="UNFAPP-grd-radio">
                            <input type="radio" name="grade" formControlName='grade' value='13th'>
                            <div class="UNFAPP-grd-radiobx">13th</div>
                        </label>
                    </li> -->
                <!-- </ul>
            </div> -->
            <ng-container *ngIf="examsFetched">
                <div class="UNFAPP-trgt-exam-area">
                    <h3 class="UNFAPP-trgt-exam-hdng">What exams are you targetting?</h3>
                    <p>Select as many.</p>
        
                    <div class="UNFAPP-trgt-examlstbx">
                        <ul class="UNFAPP-examlst" *ngIf='!isILITE'>
                            <li *ngFor="let exam of exams" >
                                <label class="UNFAPP-examlabel">
                                    <input type="checkbox" (click)="selectedTargetExamp(exam)">
                                    <div class="UNFAPP-labelinfo">
                                        <h3 class="UNFAPP-examlabel-hdng">{{exam?.displayName}}</h3>
                                        <p>{{exam.description}}</p>
                                    </div>
                                </label>
                            </li>
                        </ul>
                        <ul class="UNFAPP-examlst" *ngIf='isILITE'>
                            <li *ngFor="let exam of exams" >
                                <label class="UNFAPP-examlabel">
                                    <input type="checkbox"[checked]='iliteTargetExamId == exam.examId ? true : false' [disabled]='true' (click)="selectedTargetExamp(exam)">
                                    <div class="UNFAPP-labelinfo">
                                        <h3 class="UNFAPP-examlabel-hdng">{{exam.name}}</h3>
                                        <p>{{exam.description}}</p>
                                    </div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="UNFAPP-frm-actn-area">
                    <button class="UNFAPP-blue-btn UNFAPP-full-btn" [disabled]='!selectedExams.length' (click)="startLearning({selectedExams: selectedExams, urlData: navExtra && navExtra.urlData})">START LEARNING</button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<app-course-footer></app-course-footer>
